module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA3klEQVRIieWUMQ6CMBSG9QqoBE9gIokXY5DzuBjPwkacZGDSzUEHb2A+hz6SBlvgAQ7qvzD1+9q+n04mfx0gBI5A9il4gUk+FBYAW2DugBdAOFSQWrB4VLgIVsBVoE8fvNdMgAVwEujdksQOuG4mcvfVoio3+ZbA0rGJEoi6Cg64Y0s2veAieHgEtsQ7ky6CS4OgLonbie+CpEVgSwpgphVMgV0HSVXhVCuwq+dLCawxf3qggder5zqJrjUN8EiuKwHOmHbtVTtugqshvwcXQS7wcZ5ghyDDPLXjw786L1NAmuuZRwLlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/CustomerGroups/icons/electricity.png
// module id = 3500
// module chunks = 0